import React from "react";
import Header from "../../Components/Header/Header";
import BannerGlobal from "../../Components/Banner/BannerGlobal";
import Footer from "../../Components/Footer/Footer";
import BlogComponent2 from "../../Components/BlogComponent/BlogComponent2";
import BrandComponent from "../../Components/BrandComponent/BrandComponent";
import Mailbox from "../../Components/Footer/Mailbox";
import useDocumentTitle from "../../PageTitle";

const Blogs = () => {
  useDocumentTitle("Restaurant | Blogs")
  return (
    <div>
      <Header />
      <BannerGlobal />
      <BlogComponent2 />
      <BrandComponent />
      <Mailbox />
      <Footer />
    </div>
  );
};

export default Blogs;
